export class ItemServicoManutencao {
  constructor({
    tipoInstrumentoId,
    modeloInstrumentoId,
    servicoId,
    servicoDescricao,
    servicoValor,
    servicoCodigo,
    tipoInstrumentoNome,
    modeloInstrumentoNome,
  }) {
    this.tipoInstrumentoId = tipoInstrumentoId;
    this.modeloInstrumentoId = modeloInstrumentoId;
    this.servicoId = servicoId;
    this.servicoDescricao = servicoDescricao;
    this.valor = servicoValor;
    this.servicoCodigo = servicoCodigo;
    this.tipoInstrumentoNome = tipoInstrumentoNome;
    this.modeloInstrumentoNome = modeloInstrumentoNome;
    this.servicoValor = servicoValor;
  }
}